export const isNumber = (value: string | number | undefined | null) => {
  if (typeof value === "number" && !isNaN(value)) {
    return true;
  }
  return false;
};
